import React, { useState, useEffect } from "react";
import "./Carte.css";

import { menus, desserts } from "../../components/menus/data/Plats";

import PlatsAffichage from "../../components/menus/PlatsAffichage";
import BoissonsAffichage from "../../components/menus/BoissonsAffichage";
import VinsAffichage from "../../components/menus/VinsAffichage";
import MenusAffichage from "../../components/menus/MenusAffichage";
import DessertsAffichage from "../../components/menus/DessertsAffichage";

const Carte = () => {
  const [navLink, setNavLink] = useState(window.location.hash.substring(1));
  const [hamburger, setHamburger] = useState(false);

  useEffect(() => {
    document.title = 'Net Viet | Carte - Menu | Restaurant Vietnamien Asiatique | Restaurant Rueil-Malmaison';
  });

  useEffect(() => {
    currentNav();
  });

  function handleScroll(e) {
    /* var offsetHeight = document.getElementById('entree').offsetHeight; */
    console.log(e);
    if (
      window.pageYOffset <= document.getElementById("entrees").offsetTop &&
      window.pageYOffset >
      document.getElementById("entrees").offsetTop +
      document.getElementById("entrees").offsetHeight
    ) {
      console.log("YES");
    }
    console.log("NO");
  }

  function click(e) {
    const list = document.querySelectorAll("a[href]");
    setNavLink(e.target.id);
    for (let i = 3; i < list.length; i++) {
      if (list[i].id === e.target.id) {
        list[i].classList.add("carte_link_active");
      } else {
        list[i].classList.remove("carte_link_active");
      }
    }
  }

  function currentNav() {
    const list = document.querySelectorAll("a[href]");
    for (let i = 3; i < list.length; i++) {
      if (list[i].id === navLink) {
        list[i].classList.add("carte_link_active");
      } else {
        list[i].classList.remove("carte_link_active");
      }
    }
  }

  return (
    <div id="Carte" onScroll={handleScroll}>
      <div className="carte-content">
        <PlatsAffichage key="1" id="entrees" nom="Entrées" index={0} />
        <PlatsAffichage key="2" id="soupes" nom="Soupes" index={1} />
        <PlatsAffichage key="3" id="bo_bun" nom="Bò bún" index={2} />
        <PlatsAffichage key="4" id="nouilles" nom="Nouilles" index={3} />
        <PlatsAffichage key="5" id="specialites" nom="Spécialités" index={4} />
        <PlatsAffichage key="6" id="plats_complets" nom="Plat Complets" index={5} />
        <PlatsAffichage key="7" id="plats_vegetariens" nom="Plats Végétariens" index={6} />
        <PlatsAffichage key="8" id="accompagnement" nom="Accompagnement" index={7} />
        <MenusAffichage key="8" data={menus} />
        <VinsAffichage key="9" id="vins" nom="Vins" />
        <BoissonsAffichage key="10" id="boissons" nom="Boissons" index={0} />
        <DessertsAffichage key="11" data={desserts[0]} />
      </div>

      <div className={
        "carte-menus" +
        (hamburger ? " carte-menus__enable" : " carte__slideIn")
      }>
        {!hamburger ? (
          <div
            onClick={() => {
              setHamburger(!hamburger);
            }}
          >
            <i className="fas fa-arrow-right arrow-right"></i>
          </div>
        ) : (
          null
        )}
        {/* ============================ Link and category ==========================*/}
        <div
          className={
            "carte-menus-inside" +
            (hamburger ? " carte-menus-inside__enable" : " carte__slideIn")
          }
        >
          <ul>
            {
              hamburger ? <div
                onClick={() => {
                  setHamburger(!hamburger);
                }}
              >
                <i className={"fas fa-arrow-left arrow-left"}></i>
              </div>
                : null
            }
            <li>
              <a href="#entrees" id="entrees" onClick={click}>
                ENTREES
              </a>
            </li>
            <li>
              <a href="#soupes" id="soupes" onClick={click}>
                SOUPES
              </a>
            </li>
            <li>
              <a href="#bo_bun" id="bo_bun" onClick={click}>
                BỎ BÚN
              </a>
            </li>
            <li>
              <a href="#nouilles" id="nouilles" onClick={click}>
                NOUILLES
              </a>
            </li>
            <li>
              <a href="#specialites" id="specialites" onClick={click}>
                SPECIALITES
              </a>
            </li>
            <li>
              <a href="#plats_complets" id="plats_complets" onClick={click}>
                PLATS COMPLETS
              </a>
            </li>
            <li>
              <a
                href="#plats_vegetariens"
                id="plats_vegetariens"
                onClick={click}
              >
                PLATS VEGETARIENS
              </a>
            </li>
            <li>
              <a
                href="#accompagnement"
                id="accompagnement"
                onClick={click}
              >
                ACCOMPAGNEMENT
              </a>
            </li>
            <li>
              <a
                href="#menu_degustation_25"
                id="menu_degustation_25"
                onClick={click}
              >
                MENU DEGUSTATION 25€
              </a>
            </li>
            <li>
              <a href="#menu_midi_14" id="menu_midi_14" onClick={click}>
                MENU MIDI 14€
              </a>
            </li>
            <li>
              <a href="#menu_midi_12" id="menu_midi_12" onClick={click}>
                MENU MIDI 12€
              </a>
            </li>
            <li>
              <a href="#menu_enfant" id="menu_enfant" onClick={click}>
                MENU ENFANT
              </a>
            </li>
            <li>
              <a href="#vins" id="vins" onClick={click}>
                VINS
              </a>
            </li>
            <li>
              <a href="#boissons" id="boissons" onClick={click}>
                BOISSONS
              </a>
            </li>
            <li>
              <a href="#desserts" id="desserts" onClick={click}>
                DESSERTS
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Carte;
